import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKTuzi = () => (
  <ArticleWrapper articleId="gmk_tuzi">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Tuzi</h1>
        {/* Add your GMK Tuzi article content here */}
        <p>This is a placeholder article for the GMK Tuzi keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKTuzi;
